<template>
  <div class="panel">
    <el-col :span="12">
      <div class="glance">
        <div class="glance-title"><span>Tigo</span></div>
        <div class="glance-subtitle">Tigo is a web framework written in go.</div>
        <div class="button-group">
          <el-button class="source-button" onclick="{window.open('https://github.com/karldoenitz/Tigo', '_blank')}"
                     plain>Github Page
          </el-button>
          <el-button class="source-button"
                     onclick="{window.open('https://github.com/karldoenitz/Tigo/blob/master/documentation/documentation_en.md', '_blank')}" type="info"
                     plain>API Reference
          </el-button>
        </div>
        <div class="code"><span>$ go get github.com/karldoenitz/Tigo/...</span></div>
      </div>
    </el-col>
    <el-col :span="12">
      <img src="../../assets/tigo.png" class="tigo-logo"/>
    </el-col>
  </div>
</template>

<script>
  export default {
    name: "DocumentationHeader",
  }
</script>

<style scoped>
  .panel {
    height: 430px;
    width: auto;
    background-color: #ffffff;
    padding: 2%;
  }

  .tigo-logo {
    margin: 50px 25% 10px 50px;
    overflow: hidden;
    width: 350px;
    height: auto;
    float: left;
  }

  .glance {
    margin: 50px 50px 10px 25%;
    overflow: hidden;
    width: 350px;
    height: auto;
    float: right;
  }

  .glance-title {
    font-size: 80px;
    font-family: "Avenir", serif;
  }

  .glance-subtitle {
    margin-top: 10px;
    font-size: 18px;
    font-family: "Avenir", serif;
  }

  .button-group {
    margin-top: 30px;
  }

  .code {
    margin-top: 20px;
    background-color: #4d4d4d;
    color: #ffffff;
    padding: 3px;
    border-radius: 8px;
  }

  @media screen and (max-width: 820px) {
    .tigo-logo {
      display: none;
    }

    .el-col-12 {
      width: 100%;
    }

    .glance {
      margin: 50px 50px 10px 25%;
      overflow: hidden;
      width: 350px;
      height: auto;
      float: left;
    }
  }

  @media screen and (max-width: 484px) {
    .tigo-logo {
      display: none;
    }

    .el-col-12 {
      width: 100%;
    }

    .glance {
      margin: 50px 50px 10px 5%;
      overflow: hidden;
      width: 350px;
      height: auto;
      float: left;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/en/DocumentationHeader.vue